// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'megaphone';

export const Component = () => (
  <path d='M23.078 3c-.335 0-.479.144-.479.479v.623L2.293 6.736c-.335.048-.67.239-.91.479C1.143 7.502 1 7.838 1 8.22v7.232c0 .335.144.67.383.91.239.288.575.48.91.527l4.598.623v2.634c0 .24.143.431.43.479l4.886 1.005h.096c.335 0 .479-.143.479-.478v-2.874l9.818 1.245v.623c0 .335.144.527.479.527.335 0 .526-.192.526-.527V3.48c0-.335-.19-.48-.526-.48ZM11.823 18.134v2.395l-3.928-.767v-2.155l3.928.527ZM17.714 5.73v12.165L2.436 15.93c-.288-.047-.431-.239-.431-.479V8.22c0-.335.143-.479.43-.479l15.28-2.011Zm4.885-.623v13.458l-3.927-.527V5.586l3.927-.479Z' />
);

export const viewBox = '0 0 25 25';
